import { render, staticRenderFns } from "./AddAboutUs.vue?vue&type=template&id=7f73f874&scoped=true&"
import script from "./AddAboutUs.vue?vue&type=script&lang=js&"
export * from "./AddAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f73f874",
  null
  
)

export default component.exports